// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_textinputfour_btn-primary__2ExY9","largeLabel":"_textinputfour_largeLabel__6y8Ce"};